import configureStore from "./configureStore";
import ReactReduxConnect from "./connect";
export var store = configureStore();
export { ReactReduxConnect as connect };
